import { MoreVertical } from "react-feather";
import { Href } from "../../../../Constants/Constants";
import { useAppDispatch, useAppSelector } from "../../../../ReduxToolkit/Hooks";
import { OpenCloseSidebar, setMobileMenu } from "../../../../ReduxToolkit/Reducers/Messenger/Messenger";
import { dynamicImage, Image } from "../../../../Utils";
import SliderSection from "./SliderSection";

const RecentSection = () => {
  const dispatch = useAppDispatch();
  const { sidebarToggle } = useAppSelector((state) => state.messenger);

  const handleRightClick = () => {
    dispatch(setMobileMenu());
    document.querySelector(".main-nav")?.classList.remove("on");
    document.querySelector(".app-sidebar")?.classList.add("active");
  };
  return (
    <div className="recent">
      <div className="template-title">
        <div className="d-flex align-items-center">
          <div className="img-text">
            <div className="chat-box">
              <div className="profile">
                <Image className="bg-img img-fluid" src={dynamicImage("avtar/1.png")} alt="Avatar" />
              </div>
              <div className="details">
                <h2>Rohini Sharma</h2>
                <h4>Busy</h4>
              </div>
            </div>
          </div>
          <div className="flex-grow-1">
            <a className={`icon-btn bg-light-primary button-effect pull-right mx-2 mt-1 mobile-back ${sidebarToggle ? "btn-outline-light" : ""}`} href={Href}>
              <i className="ti-angle-right" onClick={() => handleRightClick()} />
            </a>
            <a className={`icon-btn bg-light-primary button-effect pull-right left-toggle-icon rouded15 ${sidebarToggle ? "btn-outline-light" : ""}`} href={Href} onClick={() => dispatch(OpenCloseSidebar(sidebarToggle))}>
              <MoreVertical />
            </a>
          </div>
        </div>
      </div>
      <SliderSection />
    </div>
  );
};

export default RecentSection;
